/*===== Files that compile in main.min.js =======*/

window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');

import './index.scss'

function openFrom () {
   $('.content-block, .from-block, .wrapper').addClass('active');
   $('.close-form, .overlay_bg').fadeIn();
   setTimeout(function() {
      $('.close-form').addClass('active');
   }, 250);
   $('.open-form, .overlay').fadeOut();
}

function closeForm () {
   $('.content-block, .from-block, .wrapper, .close-form').removeClass('active');
   $('.close-form, .overlay_bg').fadeOut();
   $('.open-form, .overlay').fadeIn();
}

$('.open-form').click(function() {
   if ($(window).outerWidth() > 991) {
      openFrom()
   } else {
      $('html, body').animate({
         scrollTop: $('.for-mob').offset().top
      }, 500)
   }
});

$('.overlay').click(function(e) {
   if ($(window).outerWidth() > 991) {
      openFrom()
   } else {
      return null
   }
});

$('.close-form').click(function() {
   if ($(window).outerWidth() > 991) {
      closeForm()
   } else {
      return null
   }
});

$(window).resize(function() {
   if ($(window).outerWidth() < 991) {
      closeForm()
   }
});



// WEBPACK FOOTER //
// ./src/index.js